// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader@6.8.1_webpack@5.86.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader@6.8.1_webpack@5.86.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShogiPlayer .SfenShowBlock{word-break:break-all;margin-top:var(--sp_common_gap_real_px)}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
